/**
 * A new deploy renames the hashed chunks: a tab opened on the previous version then fails to load a lazy screen
 * (« Failed to fetch dynamically imported module »). Reload once onto the new version; the session flag keeps a
 * genuinely missing chunk from looping, and is cleared once the reloaded page has been up for a while.
 */
const RELOAD_KEY = "melrys:chunk-reload";

export const isStaleChunkError = (error: unknown) =>
  /dynamically imported module|Importing a module script failed|error loading dynamically imported/i.test(
    String(error instanceof Error ? error.message : error),
  );

export function reloadOnStaleChunk(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return false;
    sessionStorage.setItem(RELOAD_KEY, "1");
  } catch {
    // storage blocked: reload anyway
  }
  window.location.reload();
  return true;
}

export function installStaleChunkReload() {
  window.addEventListener("vite:preloadError", (e) => {
    if (reloadOnStaleChunk()) e.preventDefault();
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (isStaleChunkError(e.reason)) reloadOnStaleChunk();
  });
  window.addEventListener("load", () =>
    setTimeout(() => {
      try {
        sessionStorage.removeItem(RELOAD_KEY);
      } catch {
        // ignore
      }
    }, 10_000),
  );
}
